import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/servicios-incluidos/servicio-express.gif")